import React from 'react';

export default function MarketingFooter() {
  return (
    <footer className="border-t border-white/10 bg-[#0b1423] py-6 text-center text-sm text-slate-400">
      <p>© 2026 Jelly Local. All rights reserved.</p>
    </footer>
  );
}